import React from "react";
import { motion, useReducedMotion } from "framer-motion";

/* Scroll reveal wrapper (fade-up) */
export const Reveal = ({ children, delay = 0, y = 26, className = "", as = "div" }) => {
  const reduce = useReducedMotion();
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Comp>
  );
};

/* Eyebrow / section label */
export const SectionLabel = ({ children, color = "#2563EB", className = "" }) => (
  <span
    className={`inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 ${className}`}
  >
    <span className="h-2 w-2 rounded-full" style={{ background: color }} />
    {children}
  </span>
);

/* Pass-through wrapper (magnetic cursor effect removed per design) */
export const Magnetic = ({ children, className = "" }) => (
  <span className={className}>{children}</span>
);

/* Button */
export const GlowButton = React.forwardRef(
  ({ children, onClick, className = "", variant = "primary", type = "button", ...rest }, ref) => {
    const base =
      "group relative inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 font-display text-sm sm:text-[15px] font-semibold tracking-tight transition-all duration-300 active:scale-[0.97] focus:outline-none disabled:opacity-60";
    const styles = {
      primary:
        "text-white bg-gradient-to-r from-[#2563EB] to-[#7C3AED] shadow-[0_10px_30px_-8px_rgba(37,99,235,0.5)] hover:shadow-[0_14px_38px_-8px_rgba(124,58,237,0.55)] hover:-translate-y-0.5",
      dark:
        "text-white bg-[#111827] shadow-soft hover:-translate-y-0.5 hover:bg-[#1f2937]",
      secondary:
        "text-[#111827] bg-white ring-1 ring-slate-200 shadow-sm hover:ring-slate-300 hover:-translate-y-0.5",
      whatsapp:
        "text-white bg-gradient-to-r from-emerald-500 to-green-500 shadow-[0_10px_30px_-8px_rgba(16,185,129,0.5)] hover:-translate-y-0.5",
    };
    return (
      <button
        ref={ref}
        type={type}
        onClick={onClick}
        className={`${base} ${styles[variant]} ${className}`}
        {...rest}
      >
        {children}
      </button>
    );
  },
);
GlowButton.displayName = "GlowButton";
